
import { Component, Vue, Watch } from "vue-property-decorator";
import IMessage from "@/models/toast-message";

@Component({})
export default class ToastComponent extends Vue {
  showToast = false;
  color: string = "error";
  message: string = "";

  queueMessage: IMessage[] = [];

  @Watch("queueMessage")
  onQueueMessageChange(val: IMessage[]) {
    const msg = this.$dataService.actions.shiftToastMessage();
    if (!msg) return;
    this.color = msg.color;
    this.message = msg.message;
    this.showToast = true;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  async mounted() {
    this.queueMessage = this.$dataService.getters.toastMessage();
  }
}
